import { Textarea } from "@/components/ui/textarea";
import { calculateGrade } from "@/lib/utils";
import { EvaluationReport } from "@/schema/console/evaluation-reports/EvaluationReport";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface EvaluationRowProps {
  categoryIndex: number;
  subCategoryIndex: number;
}

function EvaluationRow({
  categoryIndex,
  subCategoryIndex,
}: EvaluationRowProps) {
  const { control } = useFormContext<EvaluationReport>();
  const { t } = useTranslation();
  const {
    field: {
      value: { content, score },
    },
  } = useController({
    control,
    name: `result_index.main_category_results.${categoryIndex}.sub_category_results.${subCategoryIndex}`,
  });
  const {
    field: { value: evaluationNote, onChange },
  } = useController({
    control,
    name: `result_index.main_category_results.${categoryIndex}.sub_category_results.${subCategoryIndex}.evaluation_note`,
  });
  return (
    <div className=" flex flex-row space-x-6 px-4 py-6 items-center">
      <p className=" text-sm font-medium text-cool-gray-700 w-[200px]">
        {content}
      </p>
      <div className=" flex flex-col space-y-[2.5] w-[96px]">
        <p className=" text-sm font-medium text-cool-gray-700">
          {score ? score : "--"}
        </p>
        <p className=" text-sm font-normal text-cool-gray-500">{t("points")}</p>
      </div>
      <div className=" flex flex-col space-y-[2.5] w-[96px]">
        <p className=" text-sm font-medium text-cool-gray-700">
          {score ? calculateGrade(score) : "--"}
        </p>
        <p className=" text-sm font-normal text-cool-gray-500">{t("grade")}</p>
      </div>
      <Textarea
        value={evaluationNote ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className=" flex-grow resize-none h-[58px]"
        placeholder="Enter evaluation note"
      />
    </div>
  );
}

export default EvaluationRow;
